{
  "schema_version": "shotstead.stage-state.v1",
  "stage_id": "stage-room-001",
  "stage_version": 1,
  "parent_stage_version": null,
  "stage_status": "ready_for_rehearsal",
  "coordinate_system": {
    "units": "meters",
    "handedness": "right",
    "up_axis": "Y",
    "forward_convention": "local_negative_Z",
    "rotation_unit": "radians"
  },
  "environment": {
    "environment_ref": "procedural-room-v1",
    "transform": {
      "position": { "x": 0, "y": 0, "z": 0 },
      "rotation": { "x": 0, "y": 0, "z": 0 },
      "scale": { "x": 1, "y": 1, "z": 1 }
    }
  },
  "performers": [
    {
      "performer_id": "performer-001",
      "asset_ref": null,
      "transform": {
        "position": { "x": -2.2, "y": 0, "z": 1.4 },
        "rotation": { "x": 0, "y": -1.5708, "z": 0 },
        "scale": { "x": 1, "y": 1, "z": 1 }
      },
      "facing_target_ref": "prop-letter-001",
      "motion_ref": "procedural-walk-v1"
    }
  ],
  "props": [
    {
      "prop_id": "prop-letter-001",
      "asset_ref": null,
      "transform": {
        "position": { "x": 0.6, "y": 0.78, "z": 0.2 },
        "rotation": { "x": 0, "y": 0.2, "z": 0 },
        "scale": { "x": 1, "y": 1, "z": 1 }
      },
      "state": "on_table"
    }
  ],
  "camera": {
    "camera_id": "camera-main-001",
    "transform": {
      "position": { "x": 3.4, "y": 1.65, "z": 4.1 },
      "rotation": { "x": -0.08, "y": 0.72, "z": 0 },
      "scale": { "x": 1, "y": 1, "z": 1 }
    },
    "target_ref": "performer-001",
    "fov_degrees": 45,
    "movement": {
      "kind": "push_in",
      "start_seconds": 0.5,
      "duration_seconds": 3.5,
      "distance_meters": 0.6
    }
  },
  "motion_cues": [
    {
      "cue_id": "cue-walk-to-table",
      "performer_id": "performer-001",
      "action": "walk",
      "start_seconds": 0,
      "duration_seconds": 3,
      "path": [
        {
          "t_seconds": 0,
          "position": { "x": -2.2, "y": 0, "z": 1.4 }
        },
        {
          "t_seconds": 3,
          "position": { "x": -0.2, "y": 0, "z": 0.5 }
        }
      ],
      "target_ref": "prop-letter-001"
    },
    {
      "cue_id": "cue-look-letter",
      "performer_id": "performer-001",
      "action": "look",
      "start_seconds": 3,
      "duration_seconds": 2,
      "path": [],
      "target_ref": "prop-letter-001"
    }
  ],
  "continuity_constraints": [
    {
      "constraint_id": "keep-letter-position",
      "subject_ref": "prop-letter-001",
      "kind": "preserve_position",
      "enabled": true,
      "note": "The prop should remain fixed between camera setups."
    },
    {
      "constraint_id": "keep-performance",
      "subject_ref": "performer-001",
      "kind": "preserve_motion",
      "enabled": true,
      "note": "Take B changes camera state only; performer blocking stays unchanged."
    }
  ]
}
